import react from 'react'

import Real_estate from './../../../images/Real_estate.JPG'
import construction from './../../../images/construction.JPG'
import Investment from './../../../images/Investment.JPG'
import Remodeling from './../../../images/Remodeling.JPG'
import Infrastructure from './../../../images/Infrastructure.JPG'

import serviceBg from './../../../images/services_bg.jpg'

import serviceBgSmall from './../../../images/services_bgSmall.jpg'

import { Link } from 'react-router-dom'





const Fifth_Pane = () => (
     
     <div>

     {/**DESKTOP***/}
    <div className='uk-visible@s'
    
    
style={{ backgroundImage: `url(${serviceBg})`,
backgroundRepeat: 'no-repeat',
backgroundSize: 'cover',
paddingBottom: '80px',
paddingTop: '100px',
height: '110vh'
}}
    
    >
        <div className='uk-container mediumContainer uk-margin-remove-top'>
            <div class="uk-text-center" data-uk-grid>
                    <div class="uk-width-1-4@s">
                        <div class="uk-margin-medium-top">
                  <p className='uk-text-light uk-text-small uk-text-left' uk-scrollspy="cls: uk-animation-slide-left; repeat: true">OUR SERVICES</p>
                  
                  </div>
                    </div>
                <div class="uk-width-3-4@s">
                        <div class=""><h1 className='header1 uk-text-left' uk-scrollspy="cls: uk-animation-slide-right; repeat: true">Far far away, behind the word mountains, far from the  countries</h1></div>
                </div>
            </div>





                                    <div class="uk-text-center" data-uk-grid>
                                        <div class="uk-width-1-3@s">
                                            <div class="uk-text-left uk-padding-small">
                                                <img src = {Real_estate} uk-scrollspy="cls: uk-animation-slide-top; repeat: true"/>
                                                <h6 className=' uk-text-bold uk-text-left uk-margin-remove-top'>Real estate development</h6>
                                                <p className=' uk-text-small uk-text-left'>Separated they live in. Separated they live in Bookmarksgrove right at the coast of the Semantics.</p>
                                                <Link to = "/"><p className='uk-text-small uk-text-bold uk-margin-small-top '>Learn More</p></Link>
                                            </div>
                                        </div>
                                        <div class="uk-width-1-3@s">
                                            <div class="uk-text-left uk-padding-small uk-margin-small-top ">
                                                <img src = {construction} uk-scrollspy="cls: uk-animation-slide-top; repeat: true"/>
                                                <h6 className=' uk-text-bold uk-text-left uk-margin-remove-top'>Construction</h6>
                                                <p className=' uk-text-small uk-text-left'>Separated they live in. Separated they live in Bookmarksgrove right at the coast 
                                                of the Semantics.</p>
                                                <Link to = "/"><p className='uk-text-small uk-text-bold uk-margin-small-top ' >Learn More</p></Link>
                                            </div>

                                        </div>
                                        <div class="uk-width-1-3@s">
                                            <div class="uk-text-left uk-padding-small">
                                                <img src = {Investment}  uk-scrollspy="cls: uk-animation-slide-top; repeat: true"/>
                                                <h6 className=' uk-text-bold uk-text-left uk-margin-remove-top'>Investment</h6>
                                                <p className=' uk-text-small uk-text-left'>Separated they live in. Separated they live in Bookmarksgrove right
                                                 at the coast of the Semantics.</p>
                                                 <Link to = "/"><p className='uk-text-small uk-text-bold uk-margin-small-top '>Learn More</p></Link>
                                            </div>
                                        </div>
                                </div>




                                <div class="uk-text-center" data-uk-grid>
                                        <div class="uk-width-1-3@s ">
                                            <div class="uk-text-left uk-padding-small">
                                                <img src = {Remodeling} uk-scrollspy="cls: uk-animation-slide-top; repeat: true" />
                                                <h6 className=' uk-text-bold uk-text-left uk-margin-remove-top'>Remodeling </h6>
                                                <p className=' uk-text-small uk-text-left'>Separated they live in. Separated they live 
                                                in Bookmarksgrove right at the coast of the Semantics.</p>
                                                <Link to = "/"><p className='uk-text-small uk-text-bold  uk-margin-small-top'>Learn More</p></Link>
                                            </div>
                                        </div>
                                        <div class="uk-width-1-3@s">
                                            <div class="uk-text-left uk-padding-small">
                                                <img src = {Infrastructure}  uk-scrollspy="cls: uk-animation-slide-top; repeat: true" />
                                                <h6 className=' uk-text-bold uk-text-left uk-margin-remove-top'>Infrastructure</h6>
                                                <p className=' uk-text-small uk-text-left'>Separated they live in. Separated they live in Bookmarksgrove
                                                 right at the coast of the Semantics.</p>
                                                 <Link to = "/"><p className='uk-text-small uk-text-bold  uk-margin-small-top'>Learn More</p></Link>
                                            </div>
                                        </div>
                                        <div class="uk-width-1-3@s">
                                            <div class="uk-text-left uk-padding-small">
                                                <img src = {Real_estate}  uk-scrollspy="cls: uk-animation-slide-top; repeat: true" />
                                                <h6 className=' uk-text-bold uk-text-left uk-margin-remove-top'>Real estate development</h6>
                                                <p className=' uk-text-small uk-text-left'>Separated they live in. Separated they live in Bookmarksgrove 
                                                right at the coast of the Semantics.</p>
                                                <Link to = "/"><p className='uk-text-small uk-text-bold uk-margin-small-top '>Learn More</p></Link>
                                            </div>
                                        </div>
                                </div>

                                <div class="uk-text-center" data-uk-grid>
                                        <div class="uk-width-1-3">
                                            <div class="uk-padding-small">
                                            <Link to="/"><div class="btnCustom uk-text-center " uk-scrollspy="cls: uk-animation-slide-left; repeat: true">Contact Us</div> </Link>
                       
                                            </div>
                                        </div>
                                        <div class="uk-width-1-3">
                                            <div class=""></div>
                                        </div>
                                        <div class="uk-width-1-3">
                                            <div class=""></div>
                                        </div>
                                </div>

                                </div>               
        </div>



    
    
     {/**MOBILE***/}
     <div className='uk-hidden@s'
    
    
    style={{ backgroundImage: `url(${serviceBgSmall})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    paddingBottom: '50px',
    paddingTop: '100px',
    height: '320vh'
    }}
        
        >
            <div className='uk-container mediumContainer uk-margin-remove-top'>
                <div class="uk-text-center" data-uk-grid>
                        <div class="uk-width-1-4@s">
                            <div class="uk-margin-medium-top">
                      <p className='uk-text-light uk-text-small uk-text-left' uk-scrollspy="cls: uk-animation-slide-left; repeat: true">OUR SERVICES</p>
                      </div>
                        </div>
                    <div class="uk-width-3-4@s">
                            <div class=""><h1 className='header1 uk-text-left' uk-scrollspy="cls: uk-animation-slide-right; repeat: true">Far far away, behind the word mountains, far from the  countries</h1></div>
                    </div>
                </div>
    
    
    
    
    
                                        <div class="uk-text-center" data-uk-grid>
                                            <div class="uk-width-1-3@s">
                                                <div class="uk-text-left uk-padding-small">
                                                    <img src = {Real_estate} uk-scrollspy="cls: uk-animation-slide-top; repeat: true"/>
                                                    <h6 className=' uk-text-bold uk-text-left uk-margin-remove-top'>Real estate development</h6>
                                                    <p className=' uk-text-small uk-text-left'>Separated they live in. Separated they live in Bookmarksgrove right at the coast of the Semantics.</p>
                                                    <Link to = "/"><p className='uk-text-small uk-text-bold uk-margin-small-top '>Learn More</p></Link>
                                                </div>
                                            </div>
                                            <div class="uk-width-1-3@s">
                                                <div class="uk-text-left uk-padding-small uk-margin-small-top ">
                                                    <img src = {construction} uk-scrollspy="cls: uk-animation-slide-top; repeat: true"/>
                                                    <h6 className=' uk-text-bold uk-text-left uk-margin-remove-top'>Construction</h6>
                                                    <p className=' uk-text-small uk-text-left'>Separated they live in. Separated they live in Bookmarksgrove right at the coast 
                                                    of the Semantics.</p>
                                                    <Link to = "/"><p className='uk-text-small uk-text-bold uk-margin-small-top ' >Learn More</p></Link>
                                                </div>
    
                                            </div>
                                            <div class="uk-width-1-3@s">
                                                <div class="uk-text-left uk-padding-small">
                                                    <img src = {Investment}  uk-scrollspy="cls: uk-animation-slide-top; repeat: true"/>
                                                    <h6 className=' uk-text-bold uk-text-left uk-margin-remove-top'>Investment</h6>
                                                    <p className=' uk-text-small uk-text-left'>Separated they live in. Separated they live in Bookmarksgrove right
                                                     at the coast of the Semantics.</p>
                                                     <Link to = "/"><p className='uk-text-small uk-text-bold uk-margin-small-top '>Learn More</p></Link>
                                                </div>
                                            </div>
                                    </div>
    
    
    
    
                                    <div class="uk-text-center" data-uk-grid>
                                            <div class="uk-width-1-3@s ">
                                                <div class="uk-text-left uk-padding-small">
                                                    <img src = {Remodeling} uk-scrollspy="cls: uk-animation-slide-top; repeat: true" />
                                                    <h6 className=' uk-text-bold uk-text-left uk-margin-remove-top'>Remodeling </h6>
                                                    <p className=' uk-text-small uk-text-left'>Separated they live in. Separated they live 
                                                    in Bookmarksgrove right at the coast of the Semantics.</p>
                                                    <Link to = "/"><p className='uk-text-small uk-text-bold  uk-margin-small-top'>Learn More</p></Link>
                                                </div>
                                            </div>
                                            <div class="uk-width-1-3@s">
                                                <div class="uk-text-left uk-padding-small">
                                                    <img src = {Infrastructure}  uk-scrollspy="cls: uk-animation-slide-top; repeat: true" />
                                                    <h6 className=' uk-text-bold uk-text-left uk-margin-remove-top'>Infrastructure</h6>
                                                    <p className=' uk-text-small uk-text-left'>Separated they live in. Separated they live in Bookmarksgrove
                                                     right at the coast of the Semantics.</p>
                                                     <Link to = "/"><p className='uk-text-small uk-text-bold  uk-margin-small-top'>Learn More</p></Link>
                                                </div>
                                            </div>
                                            <div class="uk-width-1-3@s">
                                                <div class="uk-text-left uk-padding-small">
                                                    <img src = {Real_estate}  uk-scrollspy="cls: uk-animation-slide-top; repeat: true" />
                                                    <h6 className=' uk-text-bold uk-text-left uk-margin-remove-top'>Real estate development</h6>
                                                    <p className=' uk-text-small uk-text-left'>Separated they live in. Separated they live in Bookmarksgrove 
                                                    right at the coast of the Semantics.</p>
                                                    <Link to = "/"><p className='uk-text-small uk-text-bold uk-margin-small-top '>Learn More</p></Link>
                                                </div>
                                            </div>
                                    </div>
    
                                    <div class="uk-text-center" data-uk-grid>
                                            <div class="uk-width-1-3">
                                                <div class="uk-padding-small">
                                                <Link to="/"><div class="btnCustom uk-text-center " uk-scrollspy="cls: uk-animation-slide-left; repeat: true">Contact Us</div> </Link>
                           
                                                </div>
                                            </div>
                                            <div class="uk-width-1-3">
                                                <div class=""></div>
                                            </div>
                                            <div class="uk-width-1-3">
                                                <div class=""></div>
                                            </div>
                                    </div>
    
                                    </div>               
            </div>



    </div>
)


export default Fifth_Pane;